'use client';

import React from 'react';
import { Icon } from '@/components/Icons/Icon';

export interface CaptionsOverlayProps {
  /** Dismiss the captions overlay (wired to the caption toggle). */
  onClose: () => void;
}

/**
 * Parked conversation-transcript overlay. Currently rendered with
 * `display: none` (feature not yet enabled) but preserved for re-activation.
 */
export const CaptionsOverlay: React.FC<CaptionsOverlayProps> = ({ onClose }) => (
  <div
    className="absolute bottom-0 left-1/2 w-full max-w-[700px] -translate-x-1/2 -translate-y-6 transform"
    style={{ display: 'none' }}
  >
    <div className="relative z-20 flex items-start gap-5 p-4">
      <Icon name="Waveform" size={36} className="mt-1 shrink-0 text-accent-status-red" />
      <button
        onClick={onClose}
        className="shrink-0 text-white transition-colors hover:text-neutral-gray-300"
      >
        <Icon name="X" size={24} />
      </button>
    </div>
    <div className="absolute left-0 top-0 z-10 h-full w-full rounded-2xl bg-neutral-gray-800 opacity-85 backdrop-blur-sm" />
  </div>
);
